import * as env from "util/env"

export const getMetaContentByName = (name) => {
  const sel = document.querySelector("meta[name='" + name + "']")
  return sel ? sel.getAttribute("content") : null
}

const _subdomain = env.getMetaContentByName("subdomain")
const _embedded = env.getMetaContentByName("embedded")
const initialRunId = env.getMetaContentByName("run-uuid")
const rootUrl = env.getMetaContentByName("root-url")
const antiForgeryToken = env.getMetaContentByName("__anti-forgery-token")
const subsessionToken = env.getMetaContentByName("__subsession-token")
const saveProgress = env.getMetaContentByName("save-progress")

export const getSubdomain = () => {
  return _subdomain === "" ? null : _subdomain
}

export const isEmbedded = () => {
  return _embedded ? JSON.parse(_embedded) : false
}

export const getInitialRunId = () => initialRunId

export const getAntiForgeryToken = () => antiForgeryToken
export const getSubsessionToken = () => subsessionToken
export const getTokens = () => ({csrf: antiForgeryToken, subsession: subsessionToken})
export const allowSaveProgress = () => saveProgress !== "off"

export const getRootUrl = () => rootUrl
